import styled from 'styled-components';

import { NumberInput, Select } from '@dreryk/react-components';

export const StyledDosagePeriodAmountInput = styled(NumberInput)`
   width: 70px;
`;

StyledDosagePeriodAmountInput.displayName = 'StyledDosagePeriodAmountInput';

export const StyledDosagePeriodUnitSelect = styled(Select)`
   width: 116px;
` as typeof Select;
